<template>
	<div class="doctorPage managerPlan Manager">
		<div class="selectSearch">
			<el-form ref="form" :model="checkingParameter" class="qcFrom searchConditions" :inline="true">
				<el-form-item label="检查项目名称"><el-input v-model="checkingParameter.Key" class="name" placeholder="请输入检查项目名称" size="mini"></el-input></el-form-item>
				<el-form-item label="选择中心" prop="HospCode">
					<el-select size="small" v-model="checkingParameter.HospCode" style="width: 100%;" filterable placeholder="请选择中心">
						<el-option key="" label="" value="">全部</el-option>
						<el-option v-for="item in allHospitalsData.Hospitals" :key="item.HospitalGuid" :label="item.ShortName" :value="item.HospitalGuid"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="检查部位" prop="BodyPart">
					<el-select size="small" v-model="checkingParameter.BodyPart" style="width: 100%;" filterable placeholder="请选择检查部位">
						<el-option key="" label="" value="">全部</el-option>
						<el-option v-for="item in detailsRulesParameter.BodyPart" :key="item.text" :label="item.text" :value="item.text"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="扫描类型" prop="ScanType">
					<el-select size="small" v-model="checkingParameter.ScanType" style="width: 100%;" placeholder="请选择扫描类型">
						<el-option key="" label="" value="">全部</el-option>
						<el-option v-for="item in scanTypesList.ScanTypes" :key="item.ScanTypeId" :label="item.text" :value="item.ScanTypeName"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item><el-button type="primary" size="small" @click="search" round>查询</el-button></el-form-item>
				<a href="javascript:;" class="addbtn" @click="importClick()">导入检查项目</a>
			</el-form>
		</div>
		<div class="centerHome">
			<div class="ccHomel">
				<div class="compentTable">
					<el-table class="qcTable scrollbar" :data="checkingList.CheckingItems" ref="multipleTable" v-loading="loading">
						<el-table-column min-width="140" prop="CheckingItem" label="检查项目名称"></el-table-column>
						<el-table-column prop="HospName" label="中心名称"></el-table-column>
						<el-table-column prop="BodyPart" label="检查部位"></el-table-column>
						<el-table-column prop="ScanType" label="扫描类型"></el-table-column>
						<el-table-column prop="ModalityType" label="设备类型"></el-table-column>
						<el-table-column prop="" label="操作" fixed="right" width="180">
							<template slot-scope="scope">
								<span class="table-task-btn detail" @click="relationClick(scope.row, 1)">关联部位/扫描方式</span>
							</template>
						</el-table-column>
					</el-table>
					<div class="pages">
						<el-pagination
							class="pageAll"
							align="center"
							layout="prev, pager, next"
							:total="checkingList.TotalCount"
							:page-size="checkingParameter.pageCount"
							:current-page="checkingParameter.pageIndex"
							@current-change="currentChange"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="title" :visible.sync="dialog" :close-on-click-modal="false" width="60%" class="scrollbar exportFrom dialogFrom">
			<el-form label-width="100px" class="qcFrom dialogScoped" ref="setExportFrom" distinguishCancelAndClose :model="dialogList" :rules="rules">
				<el-row v-if="relationType == 0">
					<el-col :span="12">
						<el-form-item label="选择中心" prop="hospCode">
							<el-select size="small" v-model="dialogList.hospCode" style="width: 100%;" filterable placeholder="请选择中心">
								<el-option v-for="item in allHospitalsData.Hospitals" :key="item.HospitalGuid" :label="item.ShortName" :value="item.HospitalGuid"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-else>
					<el-col :span="20">
						<el-form-item label="检查部位" prop="bodyPart">
							<el-select size="small" v-model="dialogList.bodyPart" style="width: 100%;" multiple filterable placeholder="请选择检查部位">
								<el-option v-for="item in setBodyPartsList.BodyParts" :key="item.BodyPartId" :label="item.BodyPartName" :value="item.BodyPartId"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="20">
						<el-form-item label="大部位检查" prop="bodyPart">
							<el-select size="small" v-model="dialogList.bodyPart" style="width: 100%;" multiple filterable placeholder="请选择检查部位">
								<el-option v-for="item in setBodyPartsList.BodyParts" :key="item.BodyPartId" :label="item.BodyPartName" :value="item.BodyPartId"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24" class="associationPosition">
						<el-form-item label="具体部位检查" prop="specific">
							  <el-cascader
								placeholder="选择具体部位检查"
								v-model="dialogList.specific"
								:options="options"
								:props="{ multiple: true }"
								:show-all-levels="false"
								@change="handleCascaderChange"
								filterable>
							</el-cascader>
						</el-form-item>
					</el-col> -->
					<el-col :span="20">
						<el-form-item label="扫描类型" prop="scanType">
							<el-select size="small" v-model="dialogList.scanType" style="width: 100%;" multiple filterable placeholder="请选择扫描类型">
								<el-option v-for="item in scanTypesList.ScanTypes" :key="item.ScanTypeId" :label="item.ScanTypeName" :value="item.ScanTypeId"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="dialog-footer mart25" align="center"><el-button type="primary" @click="determine()">确 定</el-button></div>
		</el-dialog>
	</div>
</template>

<script>
import Api from '../../../api';
import axios from '@/js/api';
import { mapMutations, mapActions, mapState } from 'vuex';
export default {
	data() {
		var testingbodyPart= (rule, value, callback) => {
			if (this.dialogList.bodyPart.length<=0) {
				callback(new Error('请至少选择一个检查部位'));
			}else {
				callback();
			}
		}
		var testingscanType= (rule, value, callback) => {
			if(this.dialogList.scanType.length<=0){
				callback(new Error('请至少选择一个扫描类型'));
			}else {
				callback();
			}
		}
		return {
			total: 0,
			dialog: false,
			dialogList: {
				hospCode: '',
				bodyPart: [],
				scanType: []
			},
			relationType: 0,
				// bodyPart: [{
				// 	required: true,
				// 	validator: testingbodyPart,
				// 	trigger: 'change'
				// }]
			rules: {
				scanType: [{
					required: true,
					validator: testingscanType,
					trigger: 'change'
				}],
			},
			updateChecking:{
			  "CheckintItemPk": 0,
			  "BodyPartPk": [
				0
			  ],
			  "ScanTypePk": [
				0
			  ]
			},
			title:'选择影像中心',
			bodyPartDetail: [],
			activesName: '',
			options:[],
			specificParts:''
		};
	},
	computed: {
		...Vuex.mapState('breadcrumb', ['loading', 'checkingParameter', 'checkingList', 'allHospitalsData', 'detailsRulesParameter', 'scanTypesList','setBodyPartsList'])
	},
	mounted() {},
	activated() {
		this.getCheckingItemsList();
		this.getAllHospitals({
			enable: -1,
			name: '',
			pageIndex: 1,
			pageCount: 9999
		});
		this.GetBodyParts();
		this.GetScanTypes();
		this.getBodyPartDetail()
	},
	methods: {
		...Vuex.mapMutations('breadcrumb', ['setLoading']),
		...Vuex.mapActions('breadcrumb', ['getCheckingItems', 'getAllHospitals', 'GetScanTypes', 'ImportCheckingItem','UpdateCheckingItem','GetBodyParts']),
		handleCascaderChange(value) {
			// console.log(this.dialogList.specific);
			const newArray = this.dialogList.specific.map((innerArray) => {
				return innerArray.slice(1);
			});
			console.log([...newArray.flat()]);
		},
		getBodyPartDetail() {
			axios.ajaxGet('get', Api.api.manager.GetBodyPartDetail, {
				type: 1
			}).then(res => {
				this.bodyPartDetail = res.data.BodyParts;
				this.bodyPartDetail.forEach(element => {
					element.label = element.BodyPart
					element.value = element.BodyPart
					element.children = element.ChildrenBodyPart
					for (let i = 0; i < element.children.length; i++) {
						const item = element.children[i];
						item.label = item.Name
						item.value = item.Name
					}
				});
				this.options = this.bodyPartDetail
				// this.activesName = res.data.BodyParts[0].BodyPart;
			})
		},
		importClick() {
			this.relationType = 0;
			this.cleardialogList();
			this.title = '选择影像中心';
			this.dialog = true;
		},
		determine() {
			let _this = this;
			if (this.relationType == 0) {
				this.$confirm('确定导入该中心的检查项目吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(() => {
						_this
							.ImportCheckingItem({
								HospCode: _this.dialogList.hospCode
							})
							.then(res => {
								_this.dialog = false;
							});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消导入'
						});
					});
			}else{
				this.updateChecking.BodyPartPk = this.dialogList.bodyPart;
				this.updateChecking.ScanTypePk = this.dialogList.scanType;
				this.$refs.setExportFrom.validate((valid) => {
					if(valid) {
						_this.$confirm('确定关联这些部位和扫描方式吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消'
						}).then(() => {
							_this.UpdateCheckingItem(_this.updateChecking).then(res => {
								_this.dialog = false;
								_this.getCheckingItemsList();
								
							});	
						}).catch(() => {
							_this.$message({
								type: 'info',
								message: '已取消导入'
							});
						});
					} else {
						return false;
					}
				});
			}
		},
		cleardialogList(){
			this.dialogList = {
				hospCode: '',
				bodyPart: [],
				scanType: []
			}
		},
		relationClick(row, type) {
			// dialogList.bodyPart
			this.cleardialogList();
			this.title = '关联部位和扫描方式';
			this.relationType = type;
			this.dialog = true;
			this.updateChecking.CheckintItemPk = row.CheckintItemPk;
		},
		//获取列表接口
		getCheckingItemsList() {
			let _this = this;
			this.getCheckingItems();
		},
		//分页
		currentChange(val) {
			this.checkingParameter.pageIndex = val;
			this.getCheckingItemsList();
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		},
		// 搜索
		search() {
			this.checkingParameter.pageIndex = 1;
			this.getCheckingItemsList();
		}
	}
};
</script>

<style scoped>
	/* .dialogFrom >>> .el-input__inner{
		border-radius: 0 !important;
	} */
	.dialogFrom >>> .el-select__tags{
		padding-top: 10px !important;
		padding-left: 10px !important;
	}
	.el-table >>> .el-loading-mask{
		z-index: 2005 !important;
	}
	.associationPosition >>> .el-cascader__search-input{
		display: none;
	}
	.associationPosition >>> .el-cascader{
		width: 80%;
	}
	.associationPosition >>> .el-tag.el-tag--info{
		margin: 0 10px 0 0;
	}
</style>
